<template>
	<div>
        <div class="list-content">
              <div>
                <img class="image_div" :src="itemChild.bookLogoUrl" mode="" />
                <span class="book_name">{{ itemChild.bookName }}</span>
                <span class="sort" v-if="itemChild.category&&!isNine">{{
            itemChild.category.split(",")[0]
          }}</span>
              </div>
          </div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		name: 'three_conpontent',
		props: {
            itemChild:{
				type: Object,
				default: {
                }
            },
            isNine:{
              type:Boolean,
              default:false
            }
		},
		data() {
			return {
			};
		},
		watch: {
			// current(val) {
			// 	if (val !== this.currentIndex) {
			// 		this.currentIndex = val;
			// 	}
			// }
		},
		methods: {
			
		},
		created() {
		}
	};
</script>

<style  scoped>
.image_div {
  display: block;
  width: 70px;
  height: 92px;
  border-radius: 6px;
}

.book_name {
  font-size: 14px;
  color: #333333;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  width: 70px;
  margin-top: 8px;
  line-height: 20px;
  font-weight: bold;
  max-height: 40px;
}
.sort{
  font-size: 11px;
color: #888888;
  margin-top: 4px;
  line-height: 16px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/book_item/eight_compontent.vue